const WsAutofocusDirective = {
  mounted: function(el, binding) {
    const elementToFocus = typeof binding.value === "string" ? el.querySelector(binding.value) : el;
    if (!elementToFocus) {
      return;
    }
    elementToFocus.setAttribute("tabindex", "0");
    elementToFocus.focus();
  }
};
export {
  WsAutofocusDirective
};
//# sourceMappingURL=wsAutofocus.directive.es.js.map
